import { render, staticRenderFns } from "./pr.vue?vue&type=template&id=2f3f59f8"
import script from "./pr.vue?vue&type=script&lang=js"
export * from "./pr.vue?vue&type=script&lang=js"
import style0 from "./pr.vue?vue&type=style&index=0&id=2f3f59f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports